export default "__VITE_ASSET__CfcGe6ji__"